/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AddressType = {
    Address: 'Address',
    Access: 'Access',
} as const;
export type AddressType = typeof AddressType[keyof typeof AddressType];

